import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  allChanges: {
    id: 'frontbucket.repository.pullRequest.iterativeReview.allChanges',
    description: 'All changes selection label',
    defaultMessage: 'All changes',
  },
  allChangesDescription: {
    id: 'frontbucket.repository.pullRequest.iterativeReview.allChangesDescription',
    description: 'All changes description text',
    defaultMessage:
      '{commitCount, plural, one {{commitCount} commit} other {{commitCount} commits}}',
  },
  changesSinceLastReview: {
    id: 'frontbucket.repository.pullRequest.iterativeReview.changesSinceLastReview',
    description: 'Changes since last review selection label',
    defaultMessage: 'Changes since last review',
  },
  changesSinceLastReviewDescription: {
    id: 'frontbucket.repository.pullRequest.iterativeReview.changesSinceLastReviewDescription',
    description: 'Changes since last review description text',
    defaultMessage:
      '{commitCount, plural, one {{commitCount} commit} other {{commitCount} commits}} since #{hash}',
  },
  noChangesSinceLastReviewDescription: {
    id: 'frontbucket.repository.pullRequest.iterativeReview.noChangesSinceLastReviewDescription',
    description: 'No changes since last review description text',
    defaultMessage: 'No changes since last review',
  },
  individualCommitDescription: {
    id: 'frontbucket.repository.pullRequest.iterativeReview.individualCommitDescription',
    description: 'Individual commit description text',
    defaultMessage: '#{hash} on {date}',
  },
  quickSelectHeading: {
    id: 'frontbucket.repository.pullRequest.iterativeReview.quickSelectHeading',
    description: 'Quick select heading',
    defaultMessage: 'QUICK SELECT',
  },
  commitsHeading: {
    id: 'frontbucket.repository.pullRequest.iterativeReview.commitsHeading',
    description: 'Commits heading',
    defaultMessage: 'COMMITS',
  },
  singleCommitSelectorMessage: {
    id: 'frontbucket.repository.pullRequest.iterativeReview.singleCommitSelectorMessage',
    description: 'Single commit message for selector',
    defaultMessage: '#{hash}',
  },
  customDiff: {
    id: 'frontbucket.repository.pullRequest.iterativeReview.customDiff',
    description: 'Custom diff selection label',
    defaultMessage: '#{srcHash} .. {destHash}',
  },
  shiftClick: {
    id: 'frontbucket.repository.pullRequest.iterativeReview.shiftClick',
    description: 'Custom diff selection instructions',
    defaultMessage: 'shift + click for range',
  },
  customDiffFallback: {
    id: 'frontbucket.repository.pullRequest.iterativeReview.customDiffFallback',
    description: 'Custom diff fallback label',
    defaultMessage: 'Custom diff',
  },
  loadMoreCommits: {
    id: 'frontbucket.repository.pullRequest.iterativeReview.loadMoreCommits',
    description: 'Text for load more commits button',
    defaultMessage: 'Load more commits',
  },
});
